import { Fraction } from 'mathjs';

export enum Tool {
  Select,
  Write,
  Paint,
  Erase,
  KeyInput,
  Stairs,
  MonoStairs,
  Trill,
  Pattern,
};

export type KeyNote = {
  isKey: true,
  id: number,
  track: number, // TODO: nullを含める
  timePos: Fraction,
  lane: number
};

export type TrackNote = {
  isKey: false,
  id: number,
  track: number,
  timePos: Fraction,
};

export type Note = KeyNote | TrackNote;

export type CursorKeyNotePosition = {
  isKey: true,
  lane: number,
  timePos: Fraction,
  note: KeyNote | null
};

export type CursorTrackNotePosition = {
  isKey: false,
  track: number,
  timePos: Fraction,
  note: TrackNote | null
};

export type CursorNotePosition = CursorKeyNotePosition | CursorTrackNotePosition;
